import React from 'react'; 
import Background from '../../components/patientApp/background/background'
import SignoutComp from '../../components/patientApp/signout/signout';

const Signout = () => {
    return <Background>
        <SignoutComp />
    </Background>
}
export default Signout;